import { FC, useState } from "react";
import {
  useAlertStore,
  useGeneralStore,
  useThemeStore,
  useUserStore,
} from "../../../stores";
import { Row } from "../../../components/containers";
import {
  AlignItems,
  JustifyContent,
} from "../../../components/containers/types";
import HistoryFormSelector from "../history-form-selector";
import {
  HistoryQueryKindCash,
  HistoryQueryKindCheque,
  HistoryQueryKindCustomer,
  HistoryQueryKindFactor,
  Timestamp,
} from "../../../types";
import { Button } from "../../../components/buttons";
import { getRangeDay, getRangeLastMonth } from "../../../utils";
import { UserProps } from "../../admin-panel/users/types";
import { DateInput, SelectorInput } from "../../../components/inputs";
import { ActivityApi } from "../../../api";
import useHistoryPageStore from "../store";

const HistoryForm: FC = () => {
  const theme = useThemeStore((s) => s.theme);
  const users = useGeneralStore((s) => s.users);
  const user = useUserStore((s) => s.user);
  const setActivities = useHistoryPageStore((s) => s.setActivities);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  const [loading, setLoading] = useState<boolean>(false);

  const [customerFilters, setCustomerFilters] = useState<
    HistoryQueryKindCustomer[]
  >([]);
  const [factorFilters, setFactorFilters] = useState<HistoryQueryKindFactor[]>(
    []
  );
  const [chequeFilters, setChequeFilters] = useState<HistoryQueryKindCheque[]>(
    []
  );
  const [cashFilters, setCashFilters] = useState<HistoryQueryKindCash[]>([]);

  const [fromDate, setFromDate] = useState<Timestamp>(getRangeLastMonth().from);
  const [toDate, setToDate] = useState<Timestamp>(getRangeLastMonth().to);
  const [by, setBy] = useState<UserProps | null>(null);

  const onSearch = (): void => {
    setActivities([]);
    setLoading(true);
    ActivityApi.search({
      from: getRangeDay(fromDate).from,
      to: getRangeDay(toDate).to,
      kinds: [
        ...customerFilters,
        ...factorFilters,
        ...chequeFilters,
        ...cashFilters,
      ],
      by: by?._id.$oid || "",
    })
      .then((res) => {
        setActivities(res);
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      style={{
        background: theme.overlay,
        borderRadius: 15,
        minHeight: 200,
        marginTop: "1rem",
        padding: "1rem",
      }}
    >
      <Row
        justifyContent={JustifyContent.Around}
        alignItems={AlignItems.Start}
        className="history-form-row"
      >
        <HistoryFormSelector<HistoryQueryKindCustomer>
          label="از رویداد های مشتریان"
          options={{
            Customer: "همه",
            CustomerAdd: "ثبت",
            CustomerUpdate: "ویرایش",
            CustomerDelete: "حذف",
          }}
          soloField={"Customer"}
          values={customerFilters}
          setValues={setCustomerFilters}
        />

        <HistoryFormSelector<HistoryQueryKindFactor>
          label="از رویداد های فاکتورها"
          options={{
            Factor: "همه",
            FactorReceive: "دریافتی",
            FactorSpend: "خرج شده",
            FactorUpdate: "ویرایش",
            FactorDelete: "حذف",
          }}
          soloField={"Factor"}
          values={factorFilters}
          setValues={setFactorFilters}
        />

        <HistoryFormSelector<HistoryQueryKindCheque>
          label="از رویداد های چک ها"
          options={{
            Cheque: "همه",
            ChequeConfirm: "تایید",
            ChequeDeliver: "تحویل",
            ChequeUpdate: "ویرایش",
            ChequeDelete: "حذف",
          }}
          soloField={"Cheque"}
          values={chequeFilters}
          setValues={setChequeFilters}
        />

        <HistoryFormSelector<HistoryQueryKindCash>
          label="از رویداد های نقدی ها"
          options={{
            Cash: "همه",
            CashReceive: "دریافتی",
            CashSpend: "خرج شده",
            CashUpdate: "ویرایش",
            CashDelete: "حذف",
          }}
          soloField={"Cash"}
          values={cashFilters}
          setValues={setCashFilters}
        />
      </Row>

      <Row
        gap={20}
        className="finance-input-row"
        style={{ width: "100%", marginTop: "1rem" }}
      >
        <DateInput date={fromDate} label="از تاریخ" setDate={setFromDate} />

        <DateInput date={toDate} label="تا تاریخ" setDate={setToDate} />

        <SelectorInput<UserProps>
          items={!user ? users : [...users, user as UserProps]}
          label="توسط"
          compareFn={(u, v) =>
            u.fullname.toLowerCase().includes(v.toLowerCase()) ||
            u.username.toLowerCase().includes(v.toLowerCase())
          }
          renderStrings={["fullname"]}
          selected={by}
          setSelected={setBy}
          stringField={"fullname"}
          uniqueKey={"username"}
        />
      </Row>

      <Row justifyContent={JustifyContent.End} style={{ marginTop: "1rem" }}>
        <Button
          loading={loading}
          onClick={onSearch}
          background={theme.primary}
          color={theme.textOnprimary}
        >
          جستجو
        </Button>
      </Row>
    </div>
  );
};

export default HistoryForm;
